import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.scss'
import { isEmpty } from 'srcReact/helpers/validator'
import { useTranslation } from 'react-i18next'

function FilterMenu({
  filterItems,
  filterItem,
  setFilterItem,
  filterStats,
  filterClassName,
  buttonClassName,
  activeClassName,
  hasTabCount = false
}) {
  const keys = Object.keys(filterItems)
  const { t } = useTranslation()
  return (
    <section aria-label={t('global.filterSection')} className={`${styles.filterMenuWrapper} ${filterClassName}`}>
      {keys.map((key, idx) => {
        const isActive = filterItem === key
        const isDisabled = !isEmpty(filterStats) && filterStats[`total_${key}`] === 0

        return (
          <button
            {...(hasTabCount && key !== 'all'
              ? { ['aria-label']: `${parseInt(filterStats[`total_${key}`])} ${key.replace('_', ' ')}` }
              : {})}
            disabled={isDisabled}
            className={`${styles.menuButton} ${buttonClassName} ${isActive && styles.activeMenu} ${
              isActive && activeClassName
            } ${isDisabled && styles.disabledMenu}`}
            onClick={() => setFilterItem(key)}
            onMouseDown={(e) => e.preventDefault()}
            key={idx}>
            {filterItems[key]} {!isEmpty(filterStats) && key !== 'all' && `(${filterStats[`total_${key}`]})`}
          </button>
        )
      })}
    </section>
  )
}

FilterMenu.propTypes = {
  filterItems: PropTypes.object.isRequired,
  setFilterItem: PropTypes.func,
  filterItem: PropTypes.string,
  filterClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  activeClassName: PropTypes.string,
  filterStats: PropTypes.object
}

export default FilterMenu
